import { useEffect, useRef } from 'react';
import { AutoSizer, List, WindowScroller } from 'react-virtualized';

import useScreenSize from '@/hooks/useScreenSize';
import InfiniteScroll from '@/shared-components/lists/components/InfiniteScroll';

import { getUserSearchListMetrics } from '../searchConfig';

import Row from './Row';

import './styles/VirtualList.css';

export default function VirtualList({ items, onLoadMore }) {
  const screenSize = useScreenSize();
  const listRef = useRef();

  const { gap, rowHeight } = getUserSearchListMetrics(screenSize.width);

  useEffect(() => {
    listRef.current?.recomputeRowHeights();
  }, [screenSize.width, items.data.length]);

  return (
    <div className="search-view-users-virtual-list">
      <InfiniteScroll
        className="search-view-users-remove-scrollbar"
        onLoadMore={onLoadMore}
        shouldLoadMore={items.data.length < items.totalDocs}
        offsetElements={3}
        listLength={items.data.length}
        defaultInfiniteLoaderClassName="search-view-users-virtual-list-loader"
      >
        {({ infiniteScrollAssigner, infiniteScrollParent }) => (
          <WindowScroller scrollElement={infiniteScrollParent ? infiniteScrollParent : window}>
            {({ height, isScrolling, onChildScroll, scrollTop }) => (
              <AutoSizer disableHeight>
                {({ width }) => (
                  <List
                    autoHeight
                    width={width}
                    height={height}
                    isScrolling={isScrolling}
                    onScroll={onChildScroll}
                    rowCount={items.data.length}
                    rowHeight={rowHeight + gap}
                    scrollTop={scrollTop}
                    overscanRowCount={3}
                    ref={listRef}
                    rowRenderer={({ index, key, style }) => {
                      return (
                        <div
                          key={key}
                          ref={infiniteScrollAssigner(index)}
                          className="search-view-users-rows"
                          style={{ ...style, paddingBottom: gap, boxSizing: 'border-box' }}
                        >
                          <Row data={items.data[index]} />
                        </div>
                      );
                    }}
                  />
                )}
              </AutoSizer>
            )}
          </WindowScroller>
        )}
      </InfiniteScroll>
    </div>
  );
}
